import { render, staticRenderFns } from "./RecursiveModelGroup.vue?vue&type=template&id=1ef5d045&scoped=true&"
import script from "./RecursiveModelGroup.vue?vue&type=script&lang=ts&"
export * from "./RecursiveModelGroup.vue?vue&type=script&lang=ts&"
import style0 from "./RecursiveModelGroup.vue?vue&type=style&index=0&id=1ef5d045&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef5d045",
  null
  
)

export default component.exports